/**
 * Self-assignment of rota shifts - composable functions
 */
import { ref } from "vue";
import { useStore } from "vuex";
import find from "lodash/find";
import { Hub } from "aws-amplify/utils";
import { parseErrorDetails } from "@switchsystems/coactive-vue-lib";

// TODO add specific unit tests for this composable
/* v8 ignore start */
export default () => {
  const store = useStore();

  const selfAssign = ref({
    visible: false, // whether the modal dialog should be shown or not
    check: false, // checkbox to say "yes i want to self assign this shift"
    shift: {}, // the shift that we want to self-assign
    busy: false, // whether the modal should be in a busy state or not
    errorMessage: "", // any errors encountered
  });

  /**
   * Self-assign a shift
   *
   * @param {*} selectedRota
   * @param {*} user
   * @return {Object} updated rota object
   */
  async function doSelfAssign(selectedRota, user) {
    selfAssign.value.busy = true;
    selfAssign.value.errorMessage = "";

    const payload = {
      doNotCatchIfError: true,
      rotaId: selectedRota.id,
      shiftId: selfAssign.value.shift.id,
      userId: user.id,
      displayName: `${user.profile.firstName} ${user.profile.lastName}`,
    };

    return store
      .dispatch("rotas/assignUserToRota", payload)
      .then((data) => {
        selfAssign.value.busy = false;
        selfAssign.value.visible = false;
        selfAssign.value.check = false;
        Hub.dispatch("rota.shift", {
          event: "updated",
          data: find(data.shifts, { id: selfAssign.value.shift.id }),
        });
        Hub.dispatch("toast", {
          event: "success",
          message: "Shift was assigned to you successfully",
        });
        return data;
      })
      .catch((error) => {
        selfAssign.value.busy = false;
        const parsedError = parseErrorDetails(error);
        selfAssign.value.errorMessage = parsedError.message;
      });
  }

  return {
    selfAssign,
    doSelfAssign,
  };
};
/* v8 ignore stop */
